module.exports = __webpack_public_path__ + "img/44.ac70810a.jpg";